module.exports = __webpack_public_path__ + "static/media/stills-and-pipes.9fd2d3c1.png";